import { messages } from "@/messages";
import * as yup from "yup";
const validation = () => {
  return yup.object({
    segmentName: yup.string().required(messages.requiredField),
    advertiserId: yup.string().required(messages.requiredField),
  });
};
export default validation;
